import { useNavigate } from "@tanstack/react-router";
import type { Client, PortfolioSource } from "creso-core/types";
import { PortfolioImportStatus } from "web-core";

export { PortfolioSummaryComponent } from "web-core";

/**
 * Partner wrapper around the shared import-status bar: the refresh button
 * opens the MF Central import modal through the router's search params.
 */
export function PortfolioImportStatusComponent({
  selectedTab,
  client,
}: {
  selectedTab: PortfolioSource;
  client: Client;
}) {
  const navigate = useNavigate();

  return (
    <PortfolioImportStatus
      selectedTab={selectedTab}
      client={client}
      onImportHoldings={() =>
        navigate({
          to: ".",
          search: (prev) => ({
            ...prev,
            modal: "import-holdings",
          }),
        })
      }
    />
  );
}
